import api from '../utils/api';

export const fetchProviderAccounts = async () => {
    const response = await api.get('/collab-meetings/provider-accounts');
    return response.data;
};

export const saveProviderAccount = async (providerFormData, editingProviderId = null) => {
    if (editingProviderId) {
        const response = await api.put(`/collab-meetings/provider-accounts/${editingProviderId}`, providerFormData);
        return response.data;
    } else {
        const response = await api.post('/collab-meetings/provider-accounts', providerFormData);
        return response.data;
    }
};

export const deleteProviderAccount = async (id) => {
    const response = await api.delete(`/collab-meetings/provider-accounts/${id}`);
    return response.data;
};

export const testProviderAccount = async (id) => {
    const response = await api.post(`/collab-meetings/provider-accounts/${id}/test`);
    return response.data;
};

export const checkProviderAvailability = async (provider, startStr, endStr) => {
    const response = await api.post('/collab-meetings/provider-availability', {
        provider,
        start_time: startStr,
        end_time: endStr
    });
    return response.data;
};

export const fetchEscalations = async () => {
    const response = await api.get('/collab-meetings/escalations');
    return response.data;
};

export const resolveEscalation = async (escalationId, notes) => {
    const response = await api.post(`/collab-meetings/escalations/${escalationId}/resolve`, { resolution: notes });
    return response.data;
};
